// extracted by mini-css-extract-plugin
module.exports = {"dragPreview":"TableOptionsColumnDragPreview-dragPreview-2rE9T"};